.Error
    width: 100%
    height: 80px
    display: flex
    flex-direction: column
    justify-content: center
    padding: 0 28px
    color: rgb($globalErrorFont)
    font-weight: 700
    background: rgb($globalErrorBackground)
    box-sizing: border-box

.ErrorItem
    width: 100%
    display: flex
    flex-flow: row
    align-items: center
    justify-content: space-between
.Clickable
    cursor: pointer
